// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1mL3V","label":"Category_label__3f-kq","content":"Category_content__aDMc0","header":"Category_header__2hiJu","location":"Category_location__14moJ"};